import React, { useEffect, useRef } from "react";
import gsap from "gsap";

const LocationAction = ({
  fadeup,
  noMargin,
  setIsActive,
  label,
  position,
  location1
}) => {
  const actionButton = useRef(null);

  useEffect(() => {
    gsap.to(actionButton.current, {
      delay: 3,
      duration: 3,
      opacity: 1
    });
  }, []);

  return (
    <div
      ref={actionButton}
      className={`bs-action-inner`}
      data-position={position}
      data-margin={noMargin}
    >
      <a
        href={location1}
        className="bs-dropdown_button"
        target="_blank"
        rel="noreferrer"
      >
        {label}
      </a>

      {/* <div
        className="bs-location--prompt"
        data-fadeup={fadeup}
        data-position={position}
      >
        <a
          href={location1}
          className="bs-action--link"
          target="_blank"
          rel="noreferrer"
          onClick={() => setIsActive(false)}
        >
          Riverside
        </a>
      </div> */}
    </div>
  );
};

export default LocationAction;
